import config from "../../../../config";
import { ResponseDto } from '../../../../dtos/common/responseDto';
import { deleteData, getData, patchData, postData } from '../../../../utils/axios/serverHelper';
import { formatDate } from '../../../../utils/string/stringUtil';
import axios from 'axios';

import { SAL6020_R01DetailDto, SAL6020_R01Dto, SAL6020_R01HeaderDto } from './Dto_SAL6020_R01';
import { SAL6020_R01Filter } from "./Store_SAL6020_R01";

const baseUrl = `${config.apiUrl}/SAL6020_R01`;

const getParams = (filter: Partial<SAL6020_R01Filter>, listLength?: number) => {
	return {
		'salEstimateHdrDto.compCd': filter.compCd || undefined,
		'salEstimateHdrDto.customCd': filter.custInput || undefined,
		startDate: filter.dateRange?.from ? formatDate(filter.dateRange.from) : undefined,
		endDate: filter.dateRange?.to ? formatDate(filter.dateRange.to) : undefined,
		listLength: listLength || 0
	}
}

export const getSAL6020_R01List = async (option: string, params: Partial<SAL6020_R01Filter>, listLength: number = 0) => {

	const url = `${baseUrl}/${option}`;

	return await getData<ResponseDto<SAL6020_R01HeaderDto[]>>(url, { params: getParams(params, listLength) });
}

export const getSAL6020_R01AllCount = async (params: Partial<SAL6020_R01Filter>) => {
    const url = `${baseUrl}/allCount`;

    return await getData<ResponseDto<number>>(url, {
        params: getParams(params, 0)
    });
}

export const getSAL6020_R01DetailList = async (salesEstimateNo: string) => {
	const url = `${baseUrl}/detail/${salesEstimateNo}`;

	return await getData<ResponseDto<SAL6020_R01DetailDto[]>>(url);
}

export const postSAL6020_R01 = async (data: SAL6020_R01Dto) => {

	const url = `${baseUrl}`;

	return await postData<SAL6020_R01Dto, ResponseDto<SAL6020_R01Dto[]>>(url, data);
}

export const patchSAL6020_R01 = async (data: SAL6020_R01Dto) => {

	const url = `${baseUrl}`;

	return await patchData<SAL6020_R01Dto, ResponseDto<SAL6020_R01Dto[]>>(url, data);
}

export const deleteSAL6020_R01 = async (salesEstimateNo: string) => {

	const url = `${baseUrl}`;

	return await deleteData<ResponseDto<any>>(url, {
		params: {
			salesEstimateNo
		}
	});
}


export const downloadExcel_SAL6020_R01 = async (salesEstimateNo: string) => {
	const url = `${baseUrl}/excel`;
	return await getData<ResponseDto<string>>(url, {
		params: { salesEstimateNo }
	});
};
/** 견적서(수주) PDF Blob 반환 (출력은 Content에서 QZ/브라우저 폴백 처리) */
export const getPdfBlob_SAL6020_R01 = async (salesEstimateNo: string): Promise<Blob> => {
	const url = `${baseUrl}/print`;
	const response = await getData<Blob>(url, {
		params: { salesEstimateNo },
		responseType: "blob",
	});
	return new Blob([response.data], { type: "application/pdf" });
};
